import React from 'react'
import './Loader.scss'

const Loader: React.FC<{ classes?: string }> = ({ classes }) => {
	return <div className={`${classes ? `loader__${classes}` : 'loader'}`} />
}

export default Loader
